import { useTheme } from 'styled-components';

import { StyledKeylineDiv, StyledTable } from '../../../../ui/Styled';
import penceToPound from '../../../../utils/penceToPound';

const formatAnnualBillValue = (value) => {
  const absoluteValue = Math.abs(value);
  const className = value >= 0 ? 'color-exported' : 'color-imported';
  const text = value >= 0 ? `£${absoluteValue} earned` : `£${absoluteValue} spent`;

  return <strong className={className}>{text}</strong>;
};

const AnnualBill = ({ tariffCombination }) => {
  const theme = useTheme();

  const importCostWithLoop = penceToPound(tariffCombination?.optimised_tariff_results.import_cost);
  const importCostWithoutLoop = penceToPound(tariffCombination?.dumb_battery_tariff_results.import_cost);
  const exportEarningsWithLoop = penceToPound(tariffCombination?.optimised_tariff_results.export_cost);
  const exportEarningsWithoutLoop = penceToPound(tariffCombination?.dumb_battery_tariff_results.export_cost);
  const annualBillWithLoop = exportEarningsWithLoop - importCostWithLoop;
  const annualBillWithoutLoop = exportEarningsWithoutLoop - importCostWithoutLoop;

  return (
    <>
      <div className="d-none d-sm-block">
        <StyledKeylineDiv>
          <StyledTable>
            <thead>
              <tr>
                <StyledTable.Th></StyledTable.Th>
                <StyledTable.Th className="text-left">With {theme.language.appName}</StyledTable.Th>
                <StyledTable.Th className="text-left">Without {theme.language.appName}</StyledTable.Th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <StyledTable.Td className="py-4">
                  <strong>Import cost</strong>
                </StyledTable.Td>
                <StyledTable.Td>£{importCostWithLoop}</StyledTable.Td>
                <StyledTable.Td>£{importCostWithoutLoop}</StyledTable.Td>
              </tr>
              <tr>
                <StyledTable.Td className="py-4">
                  <strong>Export earnings</strong>
                </StyledTable.Td>
                <StyledTable.Td>£{exportEarningsWithLoop}</StyledTable.Td>
                <StyledTable.Td>£{exportEarningsWithoutLoop}</StyledTable.Td>
              </tr>
              <tr>
                <StyledTable.Td className="py-4">
                  <strong>Annual bill</strong>
                </StyledTable.Td>
                <StyledTable.Td>{formatAnnualBillValue(annualBillWithLoop)}</StyledTable.Td>
                <StyledTable.Td>{formatAnnualBillValue(annualBillWithoutLoop)}</StyledTable.Td>
              </tr>
            </tbody>
          </StyledTable>
        </StyledKeylineDiv>
      </div>
      <div className="d-block d-sm-none">
        <StyledKeylineDiv className="mb-4">
          <StyledTable>
            <thead>
              <tr>
                <StyledTable.Th></StyledTable.Th>
                <StyledTable.Th className="text-left">With {theme.language.appName}</StyledTable.Th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <StyledTable.Td className="py-4">
                  <strong>Import cost</strong>
                </StyledTable.Td>
                <StyledTable.Td>£{importCostWithLoop}</StyledTable.Td>
              </tr>
              <tr>
                <StyledTable.Td className="py-4">
                  <strong>Export earnings</strong>
                </StyledTable.Td>
                <StyledTable.Td>£{exportEarningsWithLoop}</StyledTable.Td>
              </tr>
              <tr>
                <StyledTable.Td className="py-4">
                  <strong>Annual bill</strong>
                </StyledTable.Td>
                <StyledTable.Td>{formatAnnualBillValue(annualBillWithLoop)}</StyledTable.Td>
              </tr>
            </tbody>
          </StyledTable>
        </StyledKeylineDiv>
        <StyledKeylineDiv>
          <StyledTable>
            <thead>
              <tr>
                <StyledTable.Th></StyledTable.Th>
                <StyledTable.Th className="text-left">Without {theme.language.appName}</StyledTable.Th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <StyledTable.Td className="py-4">
                  <strong>Import cost</strong>
                </StyledTable.Td>
                <StyledTable.Td>£{importCostWithoutLoop}</StyledTable.Td>
              </tr>
              <tr>
                <StyledTable.Td className="py-4">
                  <strong>Export earnings</strong>
                </StyledTable.Td>
                <StyledTable.Td>£{exportEarningsWithoutLoop}</StyledTable.Td>
              </tr>
              <tr>
                <StyledTable.Td className="py-4">
                  <strong>Annual bill</strong>
                </StyledTable.Td>
                <StyledTable.Td>{formatAnnualBillValue(annualBillWithoutLoop)}</StyledTable.Td>
              </tr>
            </tbody>
          </StyledTable>
        </StyledKeylineDiv>
      </div>
    </>
  );
};

export default AnnualBill;
